import type { IconProps } from './../../models/icon';

export function ShowIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        fillRule="evenodd"
        d="M23.1215 12C23.1215 11.5227 22.9641 11.0623 22.6799 10.7079C20.8799 8.52855 16.7827 4.28564 11.9998 4.28564C7.21699 4.28564 3.11984 8.52855 1.31984 10.7079C1.03554 11.0623 0.878174 11.5227 0.878174 12C0.878174 12.4774 1.03554 12.9378 1.31984 13.2922C3.11984 15.4715 7.21699 19.7144 11.9998 19.7144C16.7827 19.7144 20.8799 15.4715 22.6799 13.2922C22.9641 12.9378 23.1215 12.4774 23.1215 12ZM15.4284 11.9999C15.4284 13.8935 13.8934 15.4285 11.9998 15.4285C10.1063 15.4285 8.57127 13.8935 8.57127 11.9999C8.57127 10.1064 10.1063 8.57136 11.9998 8.57136C13.8934 8.57136 15.4284 10.1064 15.4284 11.9999Z"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M22.6799 10.7079C22.9641 11.0623 23.1215 11.5227 23.1215 12C23.1215 12.4774 22.9641 12.9378 22.6799 13.2922C20.8799 15.4715 16.7827 19.7144 11.9998 19.7144C7.21699 19.7144 3.11984 15.4715 1.31984 13.2922C1.03554 12.9378 0.878174 12.4774 0.878174 12C0.878174 11.5227 1.03554 11.0623 1.31984 10.7079C3.11984 8.52855 7.21699 4.28564 11.9998 4.28564C16.7827 4.28564 20.8799 8.52855 22.6799 10.7079Z"
      />
      <path
        fill="#fff"
        d="M12.0001 15.4287C13.8937 15.4287 15.4287 13.8937 15.4287 12.0001C15.4287 10.1066 13.8937 8.57153 12.0001 8.57153C10.1066 8.57153 8.57153 10.1066 8.57153 12.0001C8.57153 13.8937 10.1066 15.4287 12.0001 15.4287Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12.0001 15.4287C13.8937 15.4287 15.4287 13.8937 15.4287 12.0001C15.4287 10.1066 13.8937 8.57153 12.0001 8.57153C10.1066 8.57153 8.57153 10.1066 8.57153 12.0001C8.57153 13.8937 10.1066 15.4287 12.0001 15.4287Z"
      />
    </svg>
  );
}
